<script lang="ts">
  import RecordDetailHeader from "@kontextwerk/web-sdk/ui/layout/RecordDetailHeader.svelte"
  import type { PopoverMenuItem } from "@kontextwerk/web-sdk/ui/overlay/popover/types"
  import type { EmployeeOption } from "../../../../../../../../../_shared/_logic/form-state"
  import { buildScheduleEventHeader } from "./_logic/presentation"

  let {
    event,
    employees = [],
    workOrder = null,
    property = null,
    actions = [],
  }: {
    event: ScheduleEvent
    employees?: EmployeeOption[]
    workOrder?: WorkOrder | null
    property?: Property | null
    actions?: PopoverMenuItem[]
  } = $props()

  const header = $derived(buildScheduleEventHeader({ event, employees, workOrder, property }))
</script>

<RecordDetailHeader
  variant="overlay"
  headingLevel={3}
  title={header.title}
  presentation={header.presentation}
  {actions}
/>
